import type { ChatMessage, Participant } from '@crowdset/contracts';
import { create } from 'zustand';

export type RoomDialog =
  | { kind: 'report'; target: Participant | null; message?: ChatMessage }
  | { kind: 'kick'; target: Participant }
  | { kind: 'ban'; target: Participant }
  | { kind: 'skip' }
  | null;

export const useRoomDialogs = create<{
  dialog: RoomDialog;
  open(d: RoomDialog): void;
  close(): void;
}>()((set) => ({
  dialog: null,
  open: (dialog) => set({ dialog }),
  close: () => set({ dialog: null }),
}));
